// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1263":"9c87fa78e9236df1","1682":"7556a96530439c59","2012":"549c3f5295e855fb","5381":"14dca8dbf3141621","8080":"d95af5cfa8d8cc46"}[chunkId] + ".css";
};